import ViolationReportHub from './violationReportHub';
export default {
  install(app) {
    ViolationReportHub.start();
    app.config.globalProperties.$violationReportHub = ViolationReportHub;
  },
};
